import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Services, AboutUs, References, Contact } from '../pages';
import LandingPage from '../components/LandingPage';
import CADServices from '../pages/CADServices';
import CADServicesDetail from '../pages/CADServicesDetail';
import CADReferences from '../pages/CADReferences';
import Architecture from '../pages/Architecture';
import NotFound from '../pages/NotFound';

function AppRoutes() {
  return (
    <Routes>
      <Route path='/' element={<LandingPage />} />

      {/* Architecture context routes */}
      <Route path='/architecture' element={<Architecture />} />
      <Route path='/architecture/services' element={<References />} />
      <Route path='/architecture/references' element={<Services />} />

      {/* CAD context routes */}
      <Route path='/cad-services' element={<CADServices />} />
      <Route path='/cad-services/services' element={<CADServicesDetail />} />
      <Route path='/cad-services/references' element={<CADReferences />} />

      {/* Shared pages */}
      <Route path='/about-us' element={<AboutUs />} />
      <Route path='/contact' element={<Contact />} />

      {/* Legacy routes - redirect to architecture context */}
      <Route path='/services' element={<Navigate to='/architecture/services' replace />} />
      <Route path='/references' element={<Navigate to='/architecture/references' replace />} />

      {/* 404 Not Found - Must be last */}
      <Route path='*' element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;
